<template>
  <div style="height:100%; width: 100%; overflow:hidden;">
    <!-- <iframe id="iframe" v-if="show" :src="loginChannel" style="width: 0;height:0;overflow:hidden;"></iframe> -->
    <el-header class="mv-main-header">
      <div class="mv-header-logo float-l"></div>
      <div class="float-r">
        <el-dropdown>
          <span class="el-dropdown-link mv-dropdown-header">
            <img src="../assets/default.png">
            <b>{{ loginName }}</b>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="choosePro">
              <span>项目选择</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="loginOut">
              <span>退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <div class="indexNav">
      <div class="mv-main-leftmenu-icon" @click="swithMenu" style="height: 30px;">
        <i class="iconfont icon-tubiaozhizuomoban"></i>
      </div>
      <el-menu
        :default-active="onRoutes"
        background-color="#3f455b"
        text-color="#adb2c5"
        active-text-color="#adb2c5"
        class="el-menu-vertical-demo">
        <el-menu-item v-for="(value, index) in firstMenu" :key="index" :index="value.resourceUrl ? value.resourceUrl : value.name" class="indexItem" @click.native="indexMenu(value)" :style="indexStyle" style="padding: 0;">
          <i :class="value.icon"></i>
          <span slot="title">{{value.name}}</span>
        </el-menu-item>
        <!-- <el-menu-item index="valuationStrategy" @click.native="operateMenu" class="indexItem" v-bind:style="operateStyle" style="padding: 0; ">
          <i class="operateBg"></i>
          <span slot="title">运营</span>
        </el-menu-item>
        <el-menu-item index="customerAnalysis" class="indexItem" @click.native="crmMenu" :style="crmStyle" style="padding: 0;">
          <i class="crmBg"></i>
          <span slot="title">CRM</span>
        </el-menu-item>
        <el-menu-item index="paymentAnalysis" class="indexItem" @click.native="paymentMenu" :style="paymentStyle" style="padding: 0;">
          <i class="paymentBg"></i>
          <span slot="title">支付</span>
        </el-menu-item>
        <el-menu-item index="accountingAnalysis" class="indexItem" @click.native="accountMenu" :style="accountStyle" style="padding: 0;">
          <i class="accountBg"></i>
          <span slot="title">财务</span>
        </el-menu-item>
        <el-menu-item index="revenueMarket" class="indexItem" @click.native="staticMenu" :style="staticStyle" style="padding: 0;">
          <i class="staticBg"></i>
          <span slot="title">统计</span>
        </el-menu-item> -->
      </el-menu>
    </div>
    <el-aside width="200px" v-show="menuShow" :class="isCollapse ? 'menu-hide' :''">
      <div class="mv-main-leftmenu">
        <!-- <div class="mv-main-leftmenu-icon" @click="swithMenu">
          <i class="iconfont icon-tubiaozhizuomoban"></i>
        </div> -->
        <el-menu
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :collapse-transition="false"
          :unique-opened="opened"
          :default-active="onRoutes"
          background-color="#323749"
          text-color="#adb2c5"
          active-text-color="#2ee8ef"
          :router="routerDefault"
        >
          <Tree :menus="changeMenu"></Tree>
        </el-menu>
      </div>
    </el-aside>
    <div  :class="menuShow ? 'menu-left' :'mv-wrap-container'">
      <v-tags v-on:reletedCusGroup="reletedCusGroup($event)"></v-tags>
      <el-main id="mv-main-container" v-loading.fullscreen="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      >
        <keep-alive :include="tagsList">
          <router-view :key="$route.fullPath" ></router-view>
        </keep-alive>
        <!-- <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view> -->
      </el-main>
    </div>
  </div>
</template>
<script>
import Tree from './tree'
import vTags from './tab/Tags.vue'
export default {
  name: 'Boss',
  data () {
    return {
      menus: [],
      changeMenu: [],
      firstMenu: [],
      indexColor: {
        background: 'rgb(50, 55, 73)'
      },
      menuShow: false,
      indexStyle: '',
      opened: true,
      operateStyle: '',
      crmStyle: '',
      paymentStyle: '',
      accountStyle: '',
      staticStyle: '',
      tagsList: [],
      show: true,
      loginChannel: this.$API.base.loginChannel,
      isCollapse: false,
      routerDefault: true,
      loginName: ''
    }
  },
  components: {
    Tree,
    vTags
  },
  computed: {
    loading () {
      return this.$store.state.loading
    },
    onRoutes () {
      return this.$route.path
    }
  },
  watch: {
    $route (newValue, oldValue) {
      console.log(newValue)
      let _this = this
      if (newValue.path === '/homePage' || newValue.path === '/Boss') {
        this.menuShow = false
        // this.changeMenu = []
      } else {
        this.menuShow = true
        for (let v of _this.menus) {
          if (!v.resourceUrl) {
            for (let o of v.childResource) {
              if (!o.resourceUrl) {
                for (let k of o.childResource) {
                  if (k.resourceUrl && k.resourceUrl.indexOf(_this.$route.path.replace('/', '')) !== -1) {
                    _this.changeMenu = v.childResource
                  }
                }
              }
            }
          }
          if (_this.$route.path === '/copyRule' ||
            _this.$route.path === '/editRule' ||
            _this.$route.path === '/detailRule' ||
            _this.$route.path === '/addRule' ||
            _this.$route.path === '/editAbilityManage' ||
            _this.$route.path === '/addAbilityManage' ||
            _this.$route.path === '/editMaintenance' ||
            _this.$route.path === '/addMaintenance' ||
            _this.$route.path === '/maintenanceDetails' ||
            _this.$route.path === '/editCustomerInfor' ||
            _this.$route.path === '/addCustomerInfor' ||
            _this.$route.path === '/customerInforDetails' ||
            _this.$route.path === '/customerProductModifyPrice'
          ) {
            _this.menuShow = false
          }
          // if (_this.$route.path === '/paymentAnalysis') {
          //   if (v.icon === 'paymentBg') {
          //     _this.changeMenu = v.childResource
          //   }
          // }
          // if (_this.$route.path === '/accountingAnalysis') {
          //   if (v.icon === 'accountBg') {
          //     _this.changeMenu = v.childResource
          //   }
          // }
        }
      }
    }
  },
  created () {
  },
  mounted () {
    let _this = this
    let op = {
      systemName: 'Boss'
    }
    _this.loginName = localStorage.getItem('username')
    _this.$axios({
      method: 'post',
      url: _this.$API.menu.querySubSystemMenuList,
      data: op,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'mtk': localStorage.getItem('usermtk') },
      crossDomain: true
    }).then((response) => {
      let data = response.data
      if (data.resData.length && data.resData) {
        _this.menus = data.resData
        _this.firstMenu = data.resData.concat()
        console.log(_this.firstMenu)
        if (_this.$route.path === '/homePage' || _this.$route.path === '/Boss') {
          _this.menuShow = false
        } else {
          _this.menuShow = true
          for (let v of _this.menus) {
            if (!v.resourceUrl) {
              for (let o of v.childResource) {
                if (!o.resourceUrl) {
                  for (let k of o.childResource) {
                    if (k.resourceUrl && k.resourceUrl.indexOf(_this.$route.path.replace('/', '')) !== -1) {
                      _this.changeMenu = v.childResource
                    }
                  }
                }
              }
            }
            if (_this.$route.path === '/copyRule' ||
              _this.$route.path === '/editRule' ||
              _this.$route.path === '/detailRule' ||
              _this.$route.path === '/addRule' ||
              _this.$route.path === '/editAbilityManage' ||
              _this.$route.path === '/addAbilityManage' ||
              _this.$route.path === '/editMaintenance' ||
              _this.$route.path === '/addMaintenance' ||
              _this.$route.path === '/maintenanceDetails' ||
              _this.$route.path === '/editCustomerInfor' ||
              _this.$route.path === '/addCustomerInfor' ||
              _this.$route.path === '/customerInforDetails' ||
              _this.$route.path === '/customerProductModifyPrice'
            ) {
              _this.menuShow = false
            }
            // if (_this.$route.path === '/paymentAnalysis') {
            //   if (v.icon === 'paymentBg') {
            //     _this.changeMenu = v.childResource
            //   }
            // }
            // if (_this.$route.path === '/accountingAnalysis') {
            //   if (v.icon === 'accountBg') {
            //     _this.changeMenu = v.childResource
            //   }
            // }
          }
        }
      }
    }).catch((error) => {
      console.log(error)
    })
    // window.addEventListener('message', function (event) {
    //   if (event && event.data && event.data.call && event.data.call === 'loginChannel') {
    //     localStorage.setItem('username', event.data.data.username)
    //     localStorage.setItem('usermtk', event.data.data.usermtk)
    //     localStorage.setItem('userInfo', event.data.data.userInfo)
    //     _this.loginName = event.data.data.username
    //     _this.show = false
    //     _this.$axios({
    //       method: 'post',
    //       url: _this.$API.menu.querySubSystemMenuList,
    //       data: op,
    //       dataType: 'json',
    //       contentType: 'application/json; charset=utf-8',
    //       headers: { 'mtk': localStorage.getItem('usermtk') },
    //       crossDomain: true
    //     }).then((response) => {
    //       let data = response.data
    //       if (data.resData.length && data.resData) {
    //         _this.menus = data.resData
    //         console.log(_this.menus)
    //         if (_this.$route.path === '/homePage' || _this.$route.path === '/Boss') {
    //           _this.menuShow = false
    //         } else {
    //           _this.menuShow = true
    //           for (let v of _this.menus) {
    //             if (!v.resourceUrl) {
    //               for (let o of v.childResource) {
    //                 if (!o.resourceUrl) {
    //                   for (let k of o.childResource) {
    //                     if (k.resourceUrl && k.resourceUrl.indexOf(_this.$route.path.replace('/', '')) !== -1) {
    //                       _this.changeMenu = v.childResource
    //                     }
    //                   }
    //                 }
    //               }
    //             }
    //             if (_this.$route.path === '/copyRule' ||
    //               _this.$route.path === '/editRule' ||
    //               _this.$route.path === '/detailRule' ||
    //               _this.$route.path === '/addRule' ||
    //               _this.$route.path === '/editAbilityManage' ||
    //               _this.$route.path === '/addAbilityManage' ||
    //               _this.$route.path === '/editMaintenance' ||
    //               _this.$route.path === '/addMaintenance' ||
    //               _this.$route.path === '/maintenanceDetails' ||
    //               _this.$route.path === '/editCustomerInfor' ||
    //               _this.$route.path === '/addCustomerInfor' ||
    //               _this.$route.path === '/customerInforDetails' ||
    //               _this.$route.path === '/customerProductModifyPrice'
    //             ) {
    //               _this.menuShow = false
    //             }
    //             // if (_this.$route.path === '/paymentAnalysis') {
    //             //   if (v.icon === 'paymentBg') {
    //             //     _this.changeMenu = v.childResource
    //             //   }
    //             // }
    //             // if (_this.$route.path === '/accountingAnalysis') {
    //             //   if (v.icon === 'accountBg') {
    //             //     _this.changeMenu = v.childResource
    //             //   }
    //             // }
    //           }
    //         }
    //       }
    //     }).catch((error) => {
    //       console.log(error)
    //     })
    //   }
    // }, false)
  },
  methods: {
    swithMenu () {
      this.menuShow = false
    },
    operateMenu () {
      for (let v of this.menus) {
        if (v.icon === 'operateBg') {
          this.changeMenu = v.childResource
        }
      }
      this.menuShow = true
      // this.$router.push('/valuationStrategy')
      // this.operateStyle = this.indexColor
    },
    indexMenu (val) {
      if (val.icon === 'indexBg') {
        this.menuShow = false
        this.$router.push('/homePage')
      } else if (val.icon === 'operateBg') {
        for (let v of this.menus) {
          if (v.icon === 'operateBg') {
            this.changeMenu = v.childResource
          }
        }
        this.menuShow = true
      } else if (val.icon === 'crmBg') {
        for (let v of this.menus) {
          if (v.name === 'CRM') {
            this.changeMenu = v.childResource
          }
        }
        this.menuShow = true
      } else if (val.icon === 'paymentBg') {
        for (let v of this.menus) {
          if (v.icon === 'paymentBg') {
            this.changeMenu = v.childResource
          }
        }
        this.menuShow = true
      } else if (val.icon === 'accountBg') {
        for (let v of this.menus) {
          if (v.icon === 'accountBg') {
            this.changeMenu = v.childResource
          }
        }
        this.menuShow = true
      } else if (val.icon === 'staticBg') {
        for (let v of this.menus) {
          if (v.icon === 'staticBg') {
            this.changeMenu = v.childResource
          }
        }
        this.menuShow = true
      }
    },
    crmMenu () {
      console.log(this.menus)
      for (let v of this.menus) {
        if (v.name === 'CRM') {
          this.changeMenu = v.childResource
        }
      }
      this.menuShow = true
      // this.$router.push('/customerAnalysis')
    },
    paymentMenu () {
      console.log(this.menus)
      for (let v of this.menus) {
        if (v.icon === 'paymentBg') {
          this.changeMenu = v.childResource
        }
      }
      this.menuShow = true
      // this.$router.push('/paymentAnalysis')
    },
    accountMenu () {
      for (let v of this.menus) {
        if (v.icon === 'accountBg') {
          this.changeMenu = v.childResource
        }
      }
      this.menuShow = true
      // this.$router.push('/accountingAnalysis')
    },
    staticMenu () {
      for (let v of this.menus) {
        if (v.icon === 'staticBg') {
          this.changeMenu = v.childResource
        }
      }
      this.menuShow = true
      // this.$router.push('/revenueMarket')
    },
    reletedCusGroup (msg) {
      let arr = []
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name)
      }
      this.tagsList = arr
    },
    /* 项目选择 */
    choosePro () {
      window.location.href = this.$API.base.choose
    },
    /* 退出登录 */
    loginOut () {
      let _self = this
      this.$http.post(this.$API.base.loginOut, {})
        .then(function (r) {
          window.location.href = _self.$API.base.login
        }).catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.indexItem.is-active {
   background-color: rgb(50, 55, 73) !important;
}
.indexItem {
  height: 79px !important;
  line-height: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i {
    flex: 1;
    margin-top: 5px;
    margin-right: 0;
  }
  span {
    flex: 1;
    line-height: 10px;
  }
}
.operateBg {
  background: url(../assets/Operate.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  height: 18px;
}
.crmBg {
  background: url(../assets/CRM.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  height: 18px;
}
.paymentBg {
  background: url(../assets/payment.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  height: 18px;
}
.accountBg {
  background: url(../assets/Finance.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  height: 18px;
}
.staticBg {
  background: url(../assets/Statistics.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  height: 18px;
}
.indexBg {
  background: url(../assets/homepage.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  height: 18px;
}
.indexNav {
  background: #3f455b;
  width: 68px;
  height: 100%;
  display: block;
  position: absolute;
  left: 0;
  top: 50px;
  bottom: 0;
  z-index: 100;
  overflow-y: scroll;
  .mv-main-leftmenu-icon {
    background: #3f455b;
    text-align: center;
    height: 30px;
    line-height: 30px;
    color: #ced4e2;
    transition: color 0.6s, background-color 0.6s;
    -webkit-transition: color 0.6s, background-color 0.6s;
    &:hover {
      cursor: pointer;
      background: #2d2f3b;
    }
    .iconfont {
      display: inline-block;
      width: 30px;
      transform: rotate(0);
      -webkit-transform: rotate(0);
      transition: transform 0.6s;
      -webkit-transition: -webkit-transform 0.6s;
    }
  }
}
.el-aside {
  background: #2d2f3b;
  display: block;
  position: absolute;
  left: 64px;
  top: 50px;
  bottom: 0;
  z-index: 102;
  overflow-y: scroll;
}
.menu-hide {
  width: auto !important;
  .mv-main-leftmenu-icon .iconfont {
    transform: rotate(90deg) !important;
    -webkit-transform: rotate(90deg) !important;
  }
}
.el-menu {
  border-right: none !important;
}
/* .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
} */
.el-menu--collapse .mv-main-menu-hide .el-submenu__title span {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}
.el-menu--collapse
  .mv-main-menu-hide
  .el-submenu__title
  .el-submenu__icon-arrow {
  display: none;
}
.mv-main-leftmenu {
  position: relative;
  /* background: #2d2f3b;
  overflow: hidden;
  overflow-y: auto; */
  .mv-main-leftmenu-icon {
    background: #3f455b;
    text-align: center;
    height: 30px;
    line-height: 30px;
    color: #ced4e2;
    transition: color 0.6s, background-color 0.6s;
    -webkit-transition: color 0.6s, background-color 0.6s;
    &:hover {
      cursor: pointer;
      background: #2d2f3b;
    }
    .iconfont {
      display: inline-block;
      width: 30px;
      transform: rotate(0);
      -webkit-transform: rotate(0);
      transition: transform 0.6s;
      -webkit-transition: -webkit-transform 0.6s;
    }
  }
}
.mv-main-header {
  background-color: #2d2f3b;
  height: 50px !important;
  position: relative;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 100;
}
.mv-dropdown-header {
  display: inline-block;
  line-height: 50px;
  color: #96979c;
  &:hover {
    cursor: pointer;
  }
  img {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    margin-right: 10px;
    overflow: hidden;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    vertical-align: middle;
  }
}
.mv-header-logo {
  width: 250px;
  height: 100%;
  background: url(../assets/logo.png) no-repeat 16px 50%;
}
.mv-wrap-container {
  position: absolute;
  left: 64px;
  right: 0;
  top: 50px;
  bottom: 0;
}
.menu-left {
  position: absolute;
  left: 268px;
  right: 0;
  top: 50px;
  bottom: 0;
}
#mv-main-container {
  background: url(../assets/container_bg.png) no-repeat center #ecf1f5;
  background-size: auto 90%;
  width: auto;
  height: 100%;
  padding: 10px;
  overflow-y: scroll;
  box-sizing: border-box;
}
.mv-main-container-bg {
  height: 90%;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(../assets/container_bg.png) no-repeat center #ecf1f5;
  background-size: auto 90%;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue